var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5V22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22V20.5C16.6944 20.5 20.5 16.6944 20.5 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.5 9.38067 14.0724 7.07847 13.4355 5.48633C13.1155 4.68609 12.7716 4.13875 12.4668 3.81641C12.1651 3.49747 12.0069 3.5 12 3.5C11.9931 3.5 11.8349 3.49747 11.5332 3.81641C11.2284 4.13875 10.8845 4.68609 10.5645 5.48633C9.92764 7.07847 9.5 9.38067 9.5 12C9.5 14.6193 9.92764 16.9215 10.5645 18.5137C10.8845 19.3139 11.2284 19.8613 11.5332 20.1836C11.8349 20.5025 11.9931 20.5 12 20.5V22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2C14.2091 2 16 6.47715 16 12C16 17.5228 14.2091 22 12 22V20.5C12.0069 20.5 12.1651 20.5025 12.4668 20.1836C12.7716 19.8613 13.1155 19.3139 13.4355 18.5137C14.0724 16.9215 14.5 14.6193 14.5 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25V15.75H3V14.25H21Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.25V9.75H3V8.25H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.fb07ab3519b28747f2a6141e5e01a4aa.svg";
export { ForwardRef as ReactComponent };